"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupMeditationAbilityHandler = exports.GroupMeditationActorAbilityFactory = exports.GroupMeditationAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class GroupMeditationAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.GroupMeditation;
        this.__typeName = "GroupMeditation";
    }
}
exports.GroupMeditationAbilityArgs = GroupMeditationAbilityArgs;
let GroupMeditationActorAbilityFactory = class GroupMeditationActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("GroupMeditation", "AllAllies", 2);
    }
};
GroupMeditationActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("GroupMeditation")
], GroupMeditationActorAbilityFactory);
exports.GroupMeditationActorAbilityFactory = GroupMeditationActorAbilityFactory;
let GroupMeditationAbilityHandler = class GroupMeditationAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(allyId => {
                    container.applyHealing({
                        sequence: sequence,
                        healerId: ability.invokerId,
                        targetId: allyId,
                        amount: container.getPercentOfBaseHealth(allyId, 25),
                        onApplied: (sequence) => sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(allyId, "head"), "GreenExplosion"))
                    });
                });
            }
        });
    }
};
GroupMeditationAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.GroupMeditation)
], GroupMeditationAbilityHandler);
exports.GroupMeditationAbilityHandler = GroupMeditationAbilityHandler;
